import { mainAxios } from "@/mainAxios.js";
import { getAgenteAccessToken } from "../tokens.service";
import { getDefaultHeaders, getErrorMessage } from "../mainService";


export const getUsersList = async () => {
  const config = {
    headers: {
      Authorization: "Bearer " + getAgenteAccessToken(),
    },
  };

  const serverResponse = await mainAxios.post(
    "/v1/agente/list-filtro",
    {
      filtroBusqueda: '',
    },
    config
  );
  return serverResponse.data

};

export const getAgentesByFilters = async (filters, elementosPagina, pagina) => {
  try {
    const response = await mainAxios.get(
      `v1/agente/filters/area_negocio`,
      {
        ...getDefaultHeaders(),
        params: {
          filters: JSON.stringify(filters),
          limit: elementosPagina,
          page: pagina
        },

      }
    );
    return response.data;
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};


export const getAgentesFiltrosUnificados = async (filters, roles = []) => {
  try {
    const response = await mainAxios.post(
      `v1/agente/list-filtro`,
      filters,
      getDefaultHeaders()

    );

    if (roles.length > 0) {
      let usuarios = []
      roles.forEach((rol) => {
        usuarios = usuarios.concat(response.data.filter((e) => e.rol == rol));
      });
      return usuarios;
    }
    else return response.data;



  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};

export const getRolesList = async () => {
  try {
    const response = await mainAxios.get(
      `/v1/agente/roles/list`,
      getDefaultHeaders(),
    );
    let roles = response.data.sort((a, b) => {
      const nombreA = a.nombre.toUpperCase();
      const nombreB = b.nombre.toUpperCase();

      if (nombreA < nombreB) {
        return -1;
      }
      if (nombreA > nombreB) {
        return 1;
      }
      return 0;
    });
    return roles;
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};

export const postCrearUsuario = async (request) => {
  try {
    const response = await mainAxios.post(
      `/v1/agente/insert`,
      request,
      getDefaultHeaders()

    );
    
    return response.data;

  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};

export const getResponsablesAlianzas = async () => {
  try {
    const response = await mainAxios.get(
      `/v1/agente/responsables-alianzas`,
      getDefaultHeaders()
    );
    return response.data;
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};

export const getSolicitudesAgente = async () => {
  try {
    const response = await mainAxios.get(
      `/v1/solicitud/agente/list`,
      getDefaultHeaders()
    );
    return response.data;
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};

export const getAgenteById = async (agenteId) => {
  try {
    const response = await mainAxios.get(
      `v1/agente/id/${agenteId}`,
      getDefaultHeaders()
    );
    return response.data;
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
}

export const getAgentesByRolYCanal = async (body) => {
  try {
    const response = await mainAxios.get(
      `/v1/agente/por-rol-y-canal`,
      {
        ...getDefaultHeaders(),
        params: body
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};